import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/de';
import { CustomImageHandler } from '../../../../../../shared/components/CustomImageHandler';
import { truncateString } from '../../../../../../shared/functions/Functions';
import { IAllStates } from '../../../../../../store/rootReducer';
import { IMessageContent } from '../../dto/IMessage';
import { replaceCustomerSuccess } from '../../../../../../utils/helpers/customerSuccessReplace';

interface ISideChatBodyProps {
    message: IMessageContent;
}

export const SideChatBody = ({ message }: ISideChatBodyProps) => {
    const { messages, threadMetaData, subject, campaignImages } = message;
    const { unreadIDs } = useSelector((state: IAllStates) => state.message);
    const lastMessage = messages[messages?.length - 1];
    const isGroupChat = threadMetaData?.length > 1;
    const isUnread = unreadIDs.some(messageId => messageId === message?.id);
    const { i18n } = useTranslation();
    moment.locale(i18n.language);

    return (
        <>
            {isGroupChat ? (
                <CustomImageHandler
                    altTag="Influencer logo"
                    classes="user-img-rounded mr-3 box-shadow-angle"
                    thumbnailPath={campaignImages?.[0]?.thumbnail}
                    photoPath={campaignImages?.[0]?.thumbnail}
                    placeholder={'/icons/img-group-chat.svg'}
                    name={truncateString(replaceCustomerSuccess(subject) ?? '-', 30)}
                />
            ) : (
                <CustomImageHandler
                    altTag="Influencer logo"
                    classes="user-img-rounded mr-3 box-shadow-angle"
                    photoPath={threadMetaData?.[0]?.participant?.profilePhoto?.thumbnail as string}
                    thumbnailPath={threadMetaData?.[0]?.participant?.profilePhoto?.thumbnail}
                    name={truncateString(
                        `${
                            threadMetaData?.[0]?.participant?.displayName ?? threadMetaData?.[0]?.participant?.firstName
                        }-${replaceCustomerSuccess(subject) ?? '-'}`,
                        30
                    )}
                />
            )}
            <div className={`d-flex flex-column w-100 justify-content-evenly`}>
                <div className="">
                    <div
                        className={`font-weight-semi-bold mb-0 ${
                            message.type === 'customer_success' ? 'text-info bi-pin' : ''
                        }`}
                        style={{ position: 'relative' }}
                    >
                        {isGroupChat ? (
                            <>{truncateString(replaceCustomerSuccess(subject) ?? '-', 30)}</>
                        ) : (
                            <>
                                {truncateString(
                                    `${
                                        threadMetaData?.[0]?.participant?.displayName ??
                                        threadMetaData?.[0]?.participant?.firstName
                                    }-${replaceCustomerSuccess(subject) ?? '-'}`,
                                    30
                                )}
                            </>
                        )}
                        {isUnread && <div className="notSeenBubble" />}
                    </div>
                </div>
                <div className="d-flex justify-content-between align-items-center ">
                    <div
                        className={`inbox-message white-space font-weight-${
                            lastMessage?.messageMetadata?.[0]?.isRead === false ? 'semi-bold' : 'normal'
                        } d-flex w-100 justify-content-between align-items-center`}
                    >
                        {isGroupChat ? (
                            <div>
                                {truncateString(threadMetaData?.map(item => item.participant.firstName).join(', '), 25)}
                            </div>
                        ) : (
                            <div />
                        )}
                        <span className="text-primary">{moment(lastMessage?.createdAt)?.fromNow()}</span>
                    </div>
                </div>
            </div>
        </>
    );
};
